- var pacmanURL = window.__env.SITE_ORIGIN + '/pacman';

div.content-editor
    div(style='text-align: center')
        iframe(height='660px' width='510px' src=pacmanURL)

div.controls.clearfix
    a.appcues-style.btn.btn-link.btn-sm.control-link(data-action='delete'): i.fa.fa-trash
    a.appcues-style.btn.btn-primary.btn-sm.pull-right(data-action='saveAndClose') Save
